import React, { Component } from "react";
import "../style/TabletDropdown.css";
import RenderCheckboxes from "./RenderCheckboxes";

class TabletDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }
  handleOpen() {
    this.setState(currentState => ({
      open: !currentState.open
    }));
  }
  closeMenu() {
    this.setState({
      open: false
    });
  }

  render() {
    const { tags, addToState, removeFromState } = this.props;
    return (
      <div className="checkbox-items-container--tablet">
        <button onClick={this.handleOpen} className="btn">
          {this.props.name}
        </button>
        <div className="checkbox-items--tablet">
          {this.state.open && (
            <RenderCheckboxes
              tags={tags}
              addToState={addToState}
              removeFromState={removeFromState}
              closeMenuOnPress={this.closeMenu}
            />
          )}
        </div>
      </div>
    );
  }
}

export default TabletDropdown;



// WEBPACK FOOTER //
// ./src/components/TabletDropdown.js